/* eslint-disable  @typescript-eslint/no-explicit-any */
export const offlineAction = (error) => {
    if (!navigator.onLine) {
        // do nothing since offline
    }
    else {
        throw error;
    }
};
